/* @flow */

import type { StateData } from "crustate/react";

import { createStateData } from "crustate/react";

import { RouteModel } from "@crossroads/shop-state/route";
import { QuoteModel } from "state/quote";
import { CustomerModel } from "@crossroads/shop-state/customer";
import { HomeModel } from "./state/home";
import { OrderModel } from "./state/order";
import { BrandModel } from "./state/brand";
import { AllProductsModel } from "./state/all-products";
import { SearchModel } from "./state/search";
import { CmsModel } from "./state/cms";
import { MessagesModel } from "@crossroads/shop-state/messages";

export const RouteData: StateData<typeof RouteModel> =
  createStateData<typeof RouteModel>(RouteModel);
export const QuoteData: StateData<typeof QuoteModel> =
  createStateData<typeof QuoteModel>(QuoteModel);
export const CustomerData: StateData<typeof CustomerModel> =
  createStateData<typeof CustomerModel>(CustomerModel);
export const HomeData: StateData<typeof HomeModel> =
  createStateData<typeof HomeModel>(HomeModel);
export const BrandData: StateData<typeof BrandModel> =
  createStateData<typeof BrandModel>(BrandModel);
export const AllProductsData: StateData<typeof AllProductsModel> =
  createStateData<typeof AllProductsModel>(AllProductsModel);
export const SearchData: StateData<typeof SearchModel> =
  createStateData<typeof SearchModel>(SearchModel);
export const OrderData: StateData<typeof OrderModel> =
  createStateData<typeof OrderModel>(OrderModel);
export const MessagesData: StateData<typeof MessagesModel> =
  createStateData<typeof MessagesModel>(MessagesModel);
export const CmsData: StateData<typeof CmsModel> =
  createStateData<typeof CmsModel>(CmsModel);
